/**
 * Helpers de sessão UI (sem JWT).
 * Cookies HttpOnly autenticam as APIs; aqui só metadados para a interface.
 */

export const UI_USER_DATA_KEY = 'userData';
export const UI_USER_ID_KEY = 'usuario_id';
export const UI_EMAIL_KEY = 'Email';

/** Opt-in FIRMS: só `true` explícito conta como ligado (default desligado). */
export function isFirmsEmailOptIn(value) {
  return value === true;
}

export function persistUiSession(data) {
  if (!data) return;

  try {
    if (data.id != null) {
      sessionStorage.setItem(UI_USER_ID_KEY, String(data.id));
    }
    if (data.email) {
      sessionStorage.setItem(UI_EMAIL_KEY, data.email);
    }

    sessionStorage.setItem(
      UI_USER_DATA_KEY,
      JSON.stringify({
        id: data.id,
        full_name: data.full_name,
        email: data.email,
        user_type: data.user_type,
        theme: data.theme,
        receive_firms_emails: isFirmsEmailOptIn(data.receive_firms_emails),
      })
    );

    // Remover resíduos do fluxo Bearer antigo
    sessionStorage.removeItem('Authorization');
    sessionStorage.removeItem('Password');
    sessionStorage.removeItem('access_token');
    localStorage.removeItem('access_token');
  } catch {
    /* ignore quota / private mode */
  }
}

export function readUiSession() {
  try {
    const raw = sessionStorage.getItem(UI_USER_DATA_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    /* ignore */
  }

  const id = sessionStorage.getItem(UI_USER_ID_KEY);
  const email = sessionStorage.getItem(UI_EMAIL_KEY);
  if (!id && !email) return null;
  return { id, email };
}

export function hasUiSessionHint() {
  try {
    return Boolean(
      sessionStorage.getItem(UI_USER_DATA_KEY) ||
        sessionStorage.getItem(UI_USER_ID_KEY)
    );
  } catch {
    return false;
  }
}
